module.exports = __webpack_public_path__ + "img/DB.04d83323.png";